import React, { useState, useEffect } from "react";
import { bool, string } from "prop-types";
import { Link } from "gatsby";
import useGetViewportY from "../../hooks/use-get-viewport-y";
import Logo from "../../images/svg/SpotOnLogo.svg";
import LogoWhite from "../../images/svg/SpotOnLogoWhite.svg";
import phone from "../../images/svg/phone.svg";
import CtaPrimary from "../Base/CtaPrimary";

const HeaderLP = ({
  className,
  transparentHeader,
  useDarkLogo,
  phoneText,
  phoneNumber,
}) => {
  const [shouldBeTransparent, setShouldBeTransparent] = useState(false);
  const viewportY = useGetViewportY();

  useEffect(() => {
    setShouldBeTransparent(Math.abs(viewportY) <= 100 && transparentHeader);
  }, [viewportY]);

  return (
    <header
      className={`${className}
      fixed top-0 left-0 w-full z-10 h-[72px]
      flex items-center justify-between px-4 md:px-10
      ${!shouldBeTransparent ? "bg-white" : ""}
    `}
    >
      <div>
        <Link to="https://www.spoton.com" style={{ margin: "auto" }}>
          <img
            className="header__logo"
            src={shouldBeTransparent && !useDarkLogo ? LogoWhite : Logo}
            alt="logo"
          />
        </Link>
      </div>

      {phoneNumber && phoneText && (
        <div className="flex items-center justify-between gap-x-10">
          <a href={`tel:${phoneNumber}`} className="flex items-end">
            <svg
              width="18"
              height="24"
              viewBox="0 0 18 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-2.5"
            >
              <path
                d="M4.73242 23.6504C4.86719 23.7852 5.04688 23.875 5.22656 23.875C5.40625 23.9199 5.54102 23.875 5.7207 23.7402L8.5957 21.9434C8.77539 21.8535 8.86523 21.7188 8.95508 21.5391C9 21.3594 9 21.1797 8.91016 21L7.47266 17.3613C7.38281 17.2266 7.29297 17.0918 7.1582 17.002C6.97852 16.9121 6.84375 16.8672 6.66406 16.8672L4.14844 17.1367C3.69922 15.8789 3.47461 14.5312 3.47461 13.1387C3.47461 11.7461 3.69922 10.3984 4.14844 9.05078L6.66406 9.32031C6.84375 9.32031 6.97852 9.27539 7.1582 9.18555C7.29297 9.0957 7.38281 9.00586 7.47266 8.82617L8.91016 5.1875C9 5.00781 9 4.82812 8.95508 4.64844C8.86523 4.46875 8.77539 4.33398 8.5957 4.24414L5.7207 2.44727C5.54102 2.35742 5.40625 2.3125 5.22656 2.3125C5.04688 2.35742 4.86719 2.44727 4.73242 2.53711C2.8457 4.46875 1.54297 6.71484 0.869141 9.32031C0.195312 11.8359 0.195312 14.3516 0.869141 16.8672C1.49805 19.4727 2.80078 21.7637 4.73242 23.6504ZM11.4707 5.14258C11.3809 5.00781 11.2461 4.91797 11.0664 4.91797C10.8867 4.91797 10.752 4.96289 10.6172 5.05273L10.3477 5.32227C10.2578 5.41211 10.2129 5.50195 10.2129 5.5918C10.168 5.72656 10.168 5.86133 10.2578 5.95117C10.4824 6.40039 10.4824 6.84961 10.2578 7.29883C10.168 7.43359 10.168 7.56836 10.2129 7.6582C10.2129 7.79297 10.2578 7.88281 10.3477 7.92773L10.6172 8.19727C10.752 8.33203 10.8867 8.37695 11.0664 8.37695C11.2461 8.37695 11.3809 8.28711 11.4707 8.10742C11.7402 7.6582 11.875 7.16406 11.875 6.625C11.875 6.13086 11.7402 5.63672 11.4707 5.14258ZM15.6035 1.05469C15.5137 0.964844 15.3789 0.875 15.1992 0.875C15.0195 0.875 14.8848 0.919922 14.7949 1.00977L14.5703 1.2793C14.4355 1.36914 14.3906 1.50391 14.3906 1.63867C14.3906 1.81836 14.4355 1.9082 14.5254 1.99805C15.6035 3.3457 16.1875 4.91797 16.1875 6.625C16.1875 8.37695 15.6035 9.9043 14.5254 11.252C14.4355 11.3418 14.3906 11.4766 14.3906 11.6113C14.3906 11.791 14.4355 11.8809 14.5703 11.9707L14.7949 12.2402C14.8848 12.3301 15.0195 12.375 15.1992 12.375C15.3789 12.375 15.5137 12.3301 15.6035 12.1953C16.502 11.1172 17.0859 9.94922 17.4004 8.60156C17.6699 7.29883 17.6699 5.99609 17.4004 4.64844C17.0859 3.3457 16.502 2.13281 15.6035 1.05469ZM13.5371 3.07617C13.4473 2.98633 13.3125 2.89648 13.1328 2.89648C12.9531 2.89648 12.8184 2.94141 12.7285 3.03125L12.459 3.30078C12.3691 3.39062 12.2793 3.52539 12.2793 3.66016C12.2793 3.79492 12.3242 3.88477 12.4141 3.97461C12.998 4.7832 13.3125 5.63672 13.3125 6.625C13.3125 7.61328 12.998 8.51172 12.4141 9.27539C12.3242 9.36523 12.2793 9.5 12.2793 9.63477C12.2793 9.76953 12.3691 9.85938 12.459 9.94922L12.7285 10.2188C12.8184 10.3535 12.9531 10.3984 13.1328 10.3984C13.3125 10.3984 13.4473 10.3086 13.5371 10.1738C14.3457 9.14062 14.75 7.97266 14.75 6.625C14.75 5.32227 14.3457 4.1543 13.5371 3.07617Z"
                fill={shouldBeTransparent ? "white" : "#1769FF"}
              />
            </svg>

            <span
              className={`${
                shouldBeTransparent ? "text-white" : "text-primary"
              }`}
            >
              {phoneText}
            </span>
          </a>

          {/* <CtaPrimary title="Learn more" /> */}
        </div>
      )}
    </header>
  );
};

HeaderLP.propTypes = {
  className: string,
  transparentHeader: bool,
  useDarkLogo: bool,
  phoneNumber: string,
  phoneText: string,
};

HeaderLP.defaultProps = {
  className: "",
  transparentHeader: false,
  useDarkLogo: false,
  phoneText: "",
  phoneNumber: "",
};

export default HeaderLP;
